const L = {
  ACCORDION_ITEM: "HLAccordionItem",
  ACCORDION: "HLAccordion",
  ALERT: "HLAlert",
  AVATAR_GROUP: "HLAvatarGroup",
  AVATAR: "HLAvatar",
  BADGE: "HLBadge",
  TAG_GROUP: "HLTagGroup",
  BREADCRUMB_ITEM: "HLBreadcrumbItem",
  BREADCRUMB: "HLBreadcrumb",
  BUTTON_GROUP: "HLButtonGroup",
  BUTTON: "HLButton",
  CARD: "HLCard",
  CHECKBOX_CARD: "HLCheckboxCard",
  CHECKBOX_GROUP: "HLCheckboxGroup",
  CHECKBOX: "HLCheckbox",
  CODE_EDITOR: "HLCodeEditor",
  COLOR_PICKER: "HLColorPicker",
  CONTENT_SWITCHER: "HLContentSwitcher",
  CONTENT_WRAP: "HLContentWrap",
  CAROUSEL: "HLCarousel",
  DATA_TABLE_WRAPPER: "HLDataTableWrapper",
  DATA_TABLE: "HLDataTable",
  DATE_PICKER: "HLDatePicker",
  DIVIDER: "HLDivider",
  DRAGGABLE_ELEMENT: "HLDraggableElement",
  DRAWER_CONTENT: "HLDrawerContent",
  DRAWER: "HLDrawer",
  DROPDOWN: "HLDropdown",
  ELLIPSIS: "HLEllipsis",
  EMPTY: "HLEmpty",
  FEATURE_ICON: "HLFeatureIcon",
  FORM_ITEM: "HLFormItem",
  FORM: "HLForm",
  HEADER_LITE_ITEM: "HLHeaderLiteItem",
  HEADER_LITE: "HLHeaderLite",
  ICON: "HLIcon",
  INPUT_OTP: "HLInputOtp",
  INPUT_PHONE: "HLInputPhone",
  INPUT_SLIDER: "HLInputSlider",
  INPUT_TAG: "HLInputTag",
  INPUT: "HLInput",
  MENU: "HLMenu",
  MODAL: "HLModal",
  STATISTIC: "HLStatistic",
  PAGINATION: "HLPagination",
  POPOVER: "HLPopover",
  PROGRESS_STEP: "HLProgressStep",
  PROGRESS_STEPS: "HLProgressSteps",
  PROGRESS: "HLProgress",
  RADIO_CARD: "HLRadioCard",
  RADIO_GROUP: "HLRadioGroup",
  RADIO: "HLRadio",
  SECTION_FOOTER_ITEM: "HLSectionFooterItem",
  SECTION_FOOTER: "HLSectionFooter",
  SELECT: "HLSelect",
  SKELETON: "HLSkeleton",
  SPACE: "HLSpace",
  SPACING: "HLBuilderSpace",
  SPIN: "HLSpin",
  SWATCH_TILE: "HLSwatchTile",
  TAB_PANE: "HLTabPane",
  TAB: "HLTab",
  TABS: "HLTabs",
  TAG: "HLTag",
  TEXT: "HLText",
  TILE: "HLTile",
  TIME_PICKER_PANEL: "HLTimePickerPanel",
  TIME_PICKER: "HLTimePicker",
  TOGGLE_GROUP: "HLToggleGroup",
  TOGGLE: "HLToggle",
  TOOLTIP: "HLTooltip",
  UPLOAD: "HLUpload"
};
export {
  L as COMPONENT_NAME
};
